import styled from 'styled-components';
import { Format, StyleColor, NewStyleColor, BaseStyledComponentProps } from '../../../../utils/styles-constants';

interface StyledMenuItemProps extends BaseStyledComponentProps {
	isActive?: boolean;
	isBold?: boolean;
}

const MenuItemSeparator = styled('div')`
	display: block;
	position: absolute;
	top: 0;
	right: 0;
	width: calc(100% - 15px);
	height: 1px;
	background: ${StyleColor.Grey50};
`;

const StyledMenuItem = styled('div')`
	position: relative;
	font-weight: 600;

	> a {
		color: ${(props: StyledMenuItemProps) => props.isActive ? props.theme.primary.actionColor : NewStyleColor.Grey800};

		> svg {
			fill:${(props: StyledMenuItemProps) => props.isActive || props.isBold ? props.theme.primary.actionColor : NewStyleColor.Grey800};
		}
	}

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 21px;
		right: 0;
		height: 1px;
		background-color: ${StyleColor.Grey50};

		@media ${Format.SmartphoneLandscape} {
			left: 32px;
		}
	}

	${(props: StyledMenuItemProps) => props.isActive && `
		:before {
			content: '';
			display: block;
			position: absolute;
			z-index: 1;
			left: 0;
			top: 6px;
			width: calc(100% - 12px);
			height: calc(100% - 12px);
			background-color: ${props.theme.primary.actionColor};
			opacity: 0.2;
			border-radius: 0 30px 30px 0;
		}`
	};
`;

const StyledMenuItemLink = styled('a')`
	display: flex;
	position: relative;
	z-index: 2;
	align-items: center;
	padding: 21px;
	text-decoration: none;
	cursor: pointer;
	font-size: 13px;

	@media ${Format.SmartphoneLandscape} {
		padding-left: 32px;
	}

	> img {
		max-height: 18px;
		max-width: 100%;
		min-width: 18px;
		margin-right: 15px;
		flex-shrink: 0;
	}

	> svg {
		height: 18px;
		width: 18px;
		margin-right: 15px;
		flex-shrink: 0;
	}
`;

const MenuItemBadge = styled('div')`
	display: inline-block;
	padding-left: 15px;
	font-size: 13px;
	font-weight: 300;
	text-align: right;
	position: absolute;
	right: 30px;
	top: 50%;
	transform: translate(0, -50%);
	color: ${StyleColor.Grey800};
	letter-spacing: -0.15px;

	:before {
		content: '';
		width: 9px;
		height: 9px;
		border-radius: 50%;
		background: ${(props: StyledMenuItemProps) => props.theme.primary.actionColor};
		position: absolute;
		left: 0;
		top: 3px;
	}
`;

export { MenuItemBadge, MenuItemSeparator, StyledMenuItem, StyledMenuItemLink };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Left/MenuItem/styles.ts